import { render, staticRenderFns } from "./m-record.vue?vue&type=template&id=5eed2c01&scoped=true"
import script from "./m-record.vue?vue&type=script&lang=js"
export * from "./m-record.vue?vue&type=script&lang=js"
import style0 from "./m-record.vue?vue&type=style&index=0&id=5eed2c01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eed2c01",
  null
  
)

export default component.exports